export default "__VITE_ASSET__Dr4SQ0QV__"